import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import { BasePage } from '../../../../../components/BaseMain';
import { goToAdmin, goToSegmentCreate } from '../../../../../router/coordinator';
import {
  AlertMessage,
  EmptyTable,
  FilterContainer,
  HiddenForPermission,
  TitlePages
} from '../../../../../components';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { clearAlertMessage, hasPermission, isDesktop } from '../../../../../utils';
import { Button, Grid, TextField } from '@mui/material';
import { TableContainer } from '../../../../../components/TableContainer';
import { useForm } from '../../../../../hooks/useForm';
import { FilterButton } from '../../../../../components/FilterButton';
import { Order } from '../../../../../utils/enums';
import { DesktopTable } from './TablesComponents/DesktopTable';
import { listAllSegments } from '../../../../../services';
import { GENERIC_ERROR } from '../../../../../utils/constantes';
import { MobileTable } from './TablesComponents/MobileTable';

export function ListSegmentPage() {
  const navigate = useNavigate();
  const breadcrumbs = [
    { title: 'Administrativo', functionCoordinator: () => goToAdmin(navigate) },
    { title: 'Segmentos do contrato' }
  ];

  const [segments, setSegments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState({
    title: '',
    message: '',
    severity: 'error'
  });

  const [filters, onChange, clearForm] = useForm({
    title: ''
  });
  const [debouncedFilter] = useDebounce(filters, 500);

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [offset, setOffset] = useState(5);
  const [order, setOrder] = useState(Order.DESC);

  useEffect(async () => await list(), [page, offset, order, debouncedFilter]);

  const list = async () => {
    try {
      setLoading(true);

      const result = await listAllSegments(page, offset, order, filters);

      setSegments(result.data);
      setCount(result.count);

      setLoading(false);
    } catch (error) {
      setAlertMessage({ title: error.message || GENERIC_ERROR });
      setLoading(false);
    }
  };

  const handlePage = (_event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setOffset(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleOrder = () => {
    if (order === Order.ASC) {
      setOrder(Order.DESC);
      return;
    }

    setOrder(Order.ASC);
  };

  function TableResponsive() {
    if (!segments?.length && !loading) {
      return <EmptyTable />;
    }

    if (isDesktop()) {
      return (
        <DesktopTable
          segments={segments}
          loading={loading}
          count={count}
          page={page}
          offset={offset}
          order={order}
          navigate={navigate}
          handlePage={handlePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleOrder={handleOrder}
        />
      );
    }

    return (
      <MobileTable
        segments={segments}
        loading={loading}
        count={count}
        page={page}
        offset={offset}
        navigate={navigate}
        setPage={setPage}
        setOffset={setOffset}
        handlePage={handlePage}
      />
    );
  }

  return (
    <BasePage navigate={navigate} breadcrumbs={breadcrumbs}>
      <TitlePages
        title={'Lista de segmentos do contrato'}
        description={'Lista de todos os segmentos de contrato cadastrados.'}
        textButton={'Cadastrar segmento'}
        Icon={AddCircleOutlineIcon}
        onClickButton={() => goToSegmentCreate(navigate)}
        keyPermissionButton={'CREATE_SEGMENT'}
        toHideDivider={!hasPermission('LIST_SEGMENT')}
      />

      <HiddenForPermission keys="LIST_SEGMENT">
        <Grid container>
          <AlertMessage
            message={alertMessage.message}
            severity={alertMessage.severity}
            title={alertMessage.title}
            onClose={() => clearAlertMessage(setAlertMessage)}
          />
        </Grid>

        <FilterContainer>
          <Grid item xs={12} lg={3}>
            <TextField label={'Nome'} name={'title'} value={filters.title} onChange={onChange} />
          </Grid>
          <Grid item xs={12} lg={1}>
            <FilterButton onClick={clearForm} />
          </Grid>
        </FilterContainer>

        <TableContainer>
          <TableResponsive />
        </TableContainer>

        <div className={'buttonGroup twoButtons'}>
          <Button variant="outlined" onClick={() => goToAdmin(navigate)}>
            Voltar
          </Button>
          <span></span>
        </div>
      </HiddenForPermission>
    </BasePage>
  );
}
